module.exports = __webpack_public_path__ + "static/media/md-menu.4e10f85b.svg";